import React, {useEffect, useRef, useState} from 'react';

import styled, {css} from 'styled-components';

import {useBrand, useIsCartoonito} from '../../helpers';
import NitoLoader from './../../assets/animations/cnito_loader_1.json';
import NitoLoaderFlip from './../../assets/animations/cnito_loader_2.json';
// eslint-disable-next-line max-len
import CNLoaderRefreshed from './../../assets/animations/CNApp_Refreshed_Loader.json';
import DkidsLoader from './../../assets/animations/dkids-loader-mvp.json';
import {
    colors,
    mobileMediaQuery,
    tabletMediaQuery,
    tabletPortraitMediaQuery,
} from '../../styles';
import {Player} from '@lottiefiles/react-lottie-player';

const Container = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    ${props => props.padding && `padding: ${props.padding};`};
    ${props => props.margin && `margin: ${props.margin};`};
    * {
        pointer-events: none;
    }
    background-color: ${({background}) => background | '#000'};

    div:first-child {
        max-width: 100%;

        ${tabletMediaQuery} {
            max-width: 250px;
        }

        ${tabletPortraitMediaQuery} {
            max-width: 300px;
        }

        ${mobileMediaQuery} {
            max-width: 270px;
        }
    }

    ${({hide}) =>
        hide &&
        css`
            transition: opacity 0.6s linear;
            opacity: 0;
            pointer-events: none;
            position: fixed;
            height: auto;
            top: ${({top}) => top | 0}px;
            z-index: 100;
        `}
`;

const ProgressBar = styled.div`
    background-color: ${({brand}) => (brand === 'dkids' ? '#111C74' : '#fff')};
    position: relative;
    width: 350px;
    height: 9px;
    border-radius: ${({brand}) => (brand !== 'cnplus' ? '5px' : '0px')};

    ${tabletMediaQuery} {
        max-width: 250px;
    }

    ${tabletPortraitMediaQuery} {
        max-width: 300px;
    }

    ${mobileMediaQuery} {
        max-width: 270px;
    }

    ::after {
        content: '';
        position: absolute;
        background-color: ${({brand}) =>
            brand === 'dkids' ? '#7CDB5C' : colors.pink};
        width: 0%;
        height: 100%;
        top: 0px;
        left: 0px;
        bottom: 0px;
        transition: width 5s ease-out;
        border-radius: ${({brand}) => (brand !== 'cnplus' ? '5px' : '0px')};
        ${props =>
            props.duration ? `transition-duration: ${props.duration}s` : ''};
        ${props => `width: ${props.progress}%`};
    }
`;

const Loader = ({hide, background, ...props}) => {
    const containerRef = useRef();
    const animationRef = useRef();

    const brand = useBrand();
    const [progress, setProgress] = useState(0);
    const [duration, setDuration] = useState(5);
    const [isClosing, setIsClosing] = useState(false);
    const [top, setTop] = useState(undefined);
    const [animationData, setAnimationData] = useState(NitoLoader);
    const [loops, setLoops] = useState(2);
    const [isFlipping, setIsFlipping] = useState(false);

    useEffect(() => {
        setProgress(25);

        setTimeout(() => {
            setDuration(10);

            setTimeout(() => {
                setProgress(95);
            }, 100);
        }, 5000);

        return () => {
            handleClose();
        };
    }, []);

    useEffect(() => {
        if (hide) {
            handleClose();
        }
    }, [hide]);

    const handleClose = () => {
        var viewportOffset = containerRef.current.getBoundingClientRect();

        setIsClosing(true);
        setTop(viewportOffset.top);
        setDuration(0.5);
        setProgress(100);
    };
    const animationComplete = evt => {
        if (evt === 'loop' && brand === 'cnito') {
            if (!isFlipping) {
                setLoops(loops - 1);
                if (loops === 0) {
                    setAnimationData(NitoLoaderFlip);
                    setIsFlipping(true);
                }
            } else {
                setLoops(Math.floor(Math.random() * 3) + 1);
                setAnimationData(NitoLoader);
                setIsFlipping(false);
            }
        }
        //}
    };

    return (
        <Container
            ref={containerRef}
            hide={isClosing}
            background={background}
            top={top}
            {...props}
        >
            <Player
                ref={animationRef}
                src={
                    brand === 'cnito'
                        ? animationData
                        : brand === 'cnapp'
                        ? CNLoaderRefreshed
                        : DkidsLoader
                }
                style={{width: brand === 'cnito' ? 400 : 350}}
                autoplay={true}
                onEvent={animationComplete}
                loop={true}
            />

            <ProgressBar
                progress={progress}
                duration={duration}
                brand={brand}
            />
        </Container>
    );
};

export default Loader;
